'use strict';
var App = (function(proj) {
    var $html,
        $body = $('body'),
        loader = '<div class="loader"></div>',
        show_loader = true;
    var $grid;
    var slides;
    var _sessionId;

    function init( options ) {

        var defaults = {};
        var settings = $.extend({}, defaults, options);

        $html = $(document.documentElement).removeClass('no-js').addClass('js');
        this.interfaceName = $(document.body).data('interface-name');
        if ( location.toString().match(/SESS_ID=(\d+)/) ) {
            _sessionId = RegExp.$1;
        }
    }

    function showActivity() {
        if (show_loader) {
            $body.append(loader);
        }
    }

    function hideActivity() {
        $('.loader').remove();
    }

    function getJSON( action, data, handler, options ) {
        App.showActivity();
        if ( _sessionId ) {
            data.SESS_ID = _sessionId;
        }
        var url = '/json/' + action + '/';
        var errorMessage = 'Произошла ошибка при загрузке данных. Попробуйте перезагрузить страницу.';
        var settings = $.extend({
            method:    'POST',
            data:       data,
            dataType:  'json',
            checkStatus: true,
            error: function() {
                alert(errorMessage);
            },
            complete: function() {
                App.hideActivity();
            }
        }, options || {});

        settings.success = function( data, textStatus, jqXHR ) {
            if ( !settings.checkStatus || data.status ) {
                handler(data, textStatus, jqXHR);
            } else {
                alert(errorMessage);
            }
        };
        return $.ajax(url, settings);
    }

    function formPopup(selector) {
        $(selector).on('click', function(e){
            var class_name = $(this).data('class_name');
            var form_name = $(this).data('form_name');
            var object_id = $(this).data('object_id');
            var item_id = $(this).data('item_id');
            var wrap = '<div class="popup"><div class="popup__inner"><div class="popup__place"><div class="popup__block"><a href="#" class="popup__close js-popup-close"></a></div></div></div></div>';
        
            e.preventDefault();
            e.stopImmediatePropagation();
            $('body').addClass('m--popup');
            $('.wrapper').append(wrap);
            $('.popup').fadeIn(500);
            $(selector+'-close').on('click', function(){
                $('.popup').fadeOut(function(){
                    $('.popup').remove();
                    $('body').removeClass('m--popup');
                });
            });
            $(document).click(function(e) {
                if ($(e.target).closest('.popup__inner').length) return;
                e.stopPropagation();
                $('.popup').fadeOut(function(){
                    $('.popup').remove();
                    $('body').removeClass('m--popup');
                });
            });

            App.getJSON('get_'+class_name, { 'object_id': object_id, 'item_id': item_id, 'form_name': form_name }, function(data) {
                if (data.status == 'ok') {
                    //$('.popup').find('.popup__title').html(data.title);
                    $('.popup').find('.popup__block').append(data.html);
                    //$('input[type=checkbox], input[type=radio], input[type=file], select').styler();
                    console.log('Styler', $('.popup').find('input[type=file]'));
                    $('.popup').find('input[type=file]').styler({fileBrowse: 'прикрепить файл'});
                    var $form = $('.popup').find('form');
                    $form.ajaxForm({
                        beforeSend: function(){
                            $form.find(".has-error").removeClass("has-error");
                            App.showActivity();
                        },
                        success: function(e){
                            App.hideActivity();
                            answer(e);
                        },
                        error: function(e){
                            App.hideActivity();
                        },
                        type: 'POST',
                        dataType: 'json',
                        url: '/json/submit_form/',
                    });

                }
            });

        });

        function answer(json) {
            var $form = $('.popup').find('form');
            if(json.status == 'ok'){
                if(json.errors){
                    for(var i=0;i<json.errors.length;i++){
                        var attr = ".attr-"+json.errors[i];
                        $form.find(attr).addClass("has-error");
                    }
                }else{
                    $('.popup').find('.form').html('<div class="content">'+json.html+'</div>');
                    $form.clearForm();
                }
            }
        }
    }

    function initForm(selector) {
        var $form = $(selector);
        $form.ajaxForm({
            beforeSend: function(){
                $form.find(".has-error").removeClass("has-error");
                App.showActivity();
            },
            success: function(e){
                App.hideActivity();
                answer(e);
            },
            error: function(e){
                App.hideActivity();
            },
            type: 'POST',
            dataType: 'json',
            url: '/json/submit_form/',
        });

        function answer(json) {
            var $form = $(selector);
            if(json.status == 'ok'){
                if(json.errors){
                    for(var i=0;i<json.errors.length;i++){
                        var attr = ".attr-"+json.errors[i];
                        $form.find(attr).addClass("has-error");
                    }
                }else{
                    $form.clearForm();
                    $(selector+'-message').html(json.html).fadeIn(500);
                }
            }
        }
    }

    function mobileMenu(selector){
        $(selector+'-burger').on('click', function(e){
            e.preventDefault();

            $('.js-stations-close').trigger('click');

            $(selector).toggleClass('is-open');
            $(this).fadeOut(500, function(){
                $(this).toggleClass('is-open').fadeIn(500);
            });
        });
    }

//------------------------------------------------------------------------------
//------------------------------------------------------------------------------

    proj.init =              init;
    proj.showActivity =      showActivity;
    proj.hideActivity =      hideActivity;
    proj.getJSON =           getJSON;
    proj.formPopup =         formPopup;
    proj.mobileMenu =        mobileMenu;
    return proj;

})(App || {});